import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import TextView from "../components/TextView";
import PhotoView from "../components/PhotoView";
class ProgressPhotoStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType) {
    super(story, me, viewType);
  }
  getStoryDate = () => {
    return this.story.story.da;
  };
  addContentViewModel = (parts, handler) => {
    let meta = this.story.story;
    if (meta.no) {
      parts.push({
        type: TextView,
        props: {
          text: meta.no.trim(),
        },
        key: `note-${this.story.story_id}`,
      });
    }
    parts.push({
      type: PhotoView,
      props: {
        photo: meta.photo,
      },
      key: `photo-${this.story.story_id}`,
    });
  };
}
export default ProgressPhotoStoryViewModel;
